import styled from '@emotion/styled';
import { COLORS, DOTTED_FOCUS } from '../../constants';

export const StyledModalEditImageHeader = styled.div<{
  textColor?: string;
}>`
  display: block;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 29px;
  ${({ textColor }) => textColor && `color: ${textColor};`}
`;

export const StyledModalEditImageReplaceButton = styled.button<{ color: string }>`
  display: block;
  height: 42px;
  color: ${COLORS.white};
  font-size: 16px;
  font-weight: bold;
  outline: none;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  margin-top: 31px;
  margin-left: auto;
  margin-right: auto;
  background: ${({ color }) => color};

  ${DOTTED_FOCUS}

  padding: 0px 24px !important;
  position: initial !important;
  margin: 35px auto 0px !important;

  :disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`;
